import styled from "styled-components";
import { Modal, Select } from "antd";
import DatatableAntd from "components/datatable-antd";

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Title = styled.h2`
  margin-bottom: 8px;
  font-weight: bold;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CustomModal = styled(Modal)`
    position: relative;
  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #12619C;
  }

  .ant-modal-title {
    color: #fff;
    font-weight: bold;
  }

  .ant-modal-close-x {
    color: #fff;
  }

  .ant-form-item-required::before {
      content: none !important;
    }

  .ant-form-item-required::after {
    display: inline-block !important;
    margin-left: 4px !important;
    color: red;
    font-size: 14px !important;
    line-height: 1 !important;
    content: "*" !important;
  }

  .ant-modal-body {
    padding: 0;
    position: relative;

    /* height: 361.71px; */
  }
`;

export const VinculoLink = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  background: #E3F2FD;
  border: 1px solid #2196F3;
  border-radius: 16px;
  font-size: 11px;
  font-weight: 500;
  color: #1976D2;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const SelectAntd = styled(Select)`
  .ant-select-selector {
    height: 40px !important;
    border-radius: 8px !important;
    padding: 4px 11px !important;
  }
`;

export const ModalContainer = styled.div`
  padding: 24px;
`;

export const ContainerTable = styled.div<{ isOverflow: boolean }>`
   
  > div > div > div > div > div,
  > div > div > div > div > div > div,
  .ant-table-cell:has(input) {
    overflow: visible !important;
  }

   position: relative;
  width: 100%;
  .ant-table {
    table-layout: fixed !important;
  }
  .ant-table-container {
    overflow: auto !important;
  }


.ant-table-thead > tr > th,
.ant-table-tbody > tr > td {
  white-space: nowrap;
}

  .ant-select {
    cursor: text;
    min-width: 100px;
    border-radius: 0.375rem;
  }
  .ant-select-selector {
    height: 2.4rem;
  }
`;

export const RoundedTable = styled(DatatableAntd)`
  .ant-table {
    border-radius: 8px;
    overflow: hidden;
  }

  .ant-table-container {
    border-radius: 8px;
    overflow: hidden;
  }

`;

export const SpanCultura = styled.div`
  background: #e8f5e8;
  color: #2e7d32;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
`;

export const TalhoesInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;

    svg {
      font-size: 14px;
      color: #009157;
    }

    span {
      font-weight: 500;
      color: #009157;
    }
`;

export const ButtonView = styled.button`
  background: #009157;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 2px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.2s;
  display: flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  width: 100%;
  justify-content: center;

  :disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
`;

export const SpanImported = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;

  background: #e8f5e8;
  color: #2e7d32;
`;

export const Wrapper = styled.label`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const Input = styled.input`
  width: 20px;
  height: 20px;
  accent-color: #2196f3;
  flex: 0 0 auto;
`;

export const SelectAllContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
  margin-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
`;

export const SelectionSummary = styled.div`
  background: #e3f2fd;
  border: 1px solid #90caf9;
  border-radius: 8px;
  padding: 16px;
  margin-top: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  button {
    padding: 10px 16px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: all 0.2s ease;
    color: #fff;
    background: rgb(76, 175, 80);

    svg {
      font-size: 24px;
    }
  }
`;